import isTouchDevice from '@/lib/utils/isTouchDevice';
import styled from '@emotion/styled';

type CoachCommentListWrapperProps = {
  disableVisibilityStyling: boolean;
  isInLogEntry: boolean;
};

const CoachCommentListWrapper = styled('section')<CoachCommentListWrapperProps>(
  ({ theme, disableVisibilityStyling, isInLogEntry }) => ({
    position: disableVisibilityStyling ? undefined : 'relative',
    marginTop: isInLogEntry ? 16 : 12,
    paddingLeft: 32,
    transition: theme.transitions.create(['margin-top', 'margin-bottom']),
  }),
  ({ disableVisibilityStyling, isInLogEntry }) => {
    if (isTouchDevice()) {
      return {
        marginTop: `${disableVisibilityStyling ? 0 : isInLogEntry ? 16 : 12}px !important`,
        marginBottom: '0 !important',
        height: 'auto !important',
      };
    }
  },
);

export default CoachCommentListWrapper;
